var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk25127430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 143.6 30",
    style: {
      enableBackground: "new 0 0 143.6 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 87.6,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 8.262 48.756)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.9,
    y: 7.4,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 32.355 98.7782)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.7,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.1,30H85.3V0.4h29.8V30z M86.5,28.9h27.5V1.5H86.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.2,26H88.7V4h22.5V26z M89.8,24.8H110V5.1H89.8V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    y: -6.2,
    transform: "matrix(0.4704 -0.8824 0.8824 0.4704 0.1749 15.9913)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -8.8761 9.6309)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.4,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8,30H0V0.4h29.8V30z M1.1,28.9h27.5V1.5H1.1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4,26H3.9V4h22.5V26z M5,24.8h20.2V5.1H5V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.2,
    y: -6.2,
    transform: "matrix(0.4702 -0.8825 0.8825 0.4702 15.1909 41.0067)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.9,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -5.1104 23.7489)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1,30H28.3V0.4h29.8V30z M29.5,28.9H57V1.5H29.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7,26H32.2V4h22.5V26z M33.4,24.8h20.2V5.1H33.4V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.8,
    y: -6.2,
    transform: "matrix(0.4704 -0.8825 0.8825 0.4704 30.3457 66.2641)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 20.9,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -1.3083 38.0034)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.3,
    y: 11.2,
    width: 3.5,
    height: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,30H57V0.4h29.8V30z M58.1,28.9h27.5V1.5H58.1V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4,26H60.9V4h22.5V26z M62,24.8h20.2V5.1H62V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.1,
    y: 7.3,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 11.6116 62.1576)",
    width: 28.1,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.4,
    y: 7.4,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 46.6624 123.484)",
    width: 1.1,
    height: 28.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.6,30h-29.8V0.4h29.8V30z M114.9,28.9h27.5V1.5h-27.5V28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.7,26h-22.5V4h22.5V26z M118.3,24.8h20.2V5.1h-20.2V24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9,29.6l-0.2-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l2-4.1c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-2,4.1 C58.3,29.5,58.1,29.6,57.9,29.6z M61.4,22.4l-0.2-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l2-4.1c0.1-0.3,0.5-0.4,0.8-0.3 c0.3,0.1,0.4,0.5,0.3,0.8l-2,4.1C61.8,22.3,61.6,22.4,61.4,22.4z M64.8,15.2l-0.2-0.1c-0.3-0.1-0.4-0.5-0.3-0.8l2-4.1 c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-2,4.1C65.2,15.1,65,15.2,64.8,15.2z M68.3,8.1L68,8c-0.3-0.1-0.4-0.5-0.3-0.8 l2-4.1c0.1-0.3,0.5-0.4,0.8-0.3c0.3,0.1,0.4,0.5,0.3,0.8l-2,4.1C68.7,7.9,68.5,8.1,68.3,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4,29.6c-0.2,0-0.4-0.1-0.5-0.3l-2.1-4c-0.1-0.3,0-0.6,0.2-0.8c0.3-0.1,0.6,0,0.8,0.2l2.1,4c0.1,0.3,0,0.6-0.2,0.8 L86.4,29.6z M82.7,22.5c-0.2,0-0.4-0.1-0.5-0.3l-2.1-4c-0.1-0.3,0-0.6,0.2-0.8c0.3-0.1,0.6,0,0.8,0.2l2.1,4c0.1,0.3,0,0.6-0.2,0.8 L82.7,22.5z M79.1,15.5c-0.2,0-0.4-0.1-0.5-0.3l-2.1-4c-0.1-0.3,0-0.6,0.2-0.8c0.3-0.1,0.6,0,0.8,0.2l2.1,4c0.1,0.3,0,0.6-0.2,0.8 L79.1,15.5z M75.4,8.4c-0.2,0-0.4-0.1-0.5-0.3l-2.1-4c-0.1-0.3,0-0.6,0.2-0.8c0.3-0.1,0.6,0,0.8,0.2l2.1,4c0.1,0.3,0,0.6-0.2,0.8 L75.4,8.4z M71.7,1.3c-0.2,0-0.4-0.1-0.5-0.3l-0.1-0.2c-0.1-0.3,0-0.6,0.2-0.8c0.3-0.1,0.6,0,0.8,0.2l0.1,0.2 c0.1,0.3,0,0.6-0.2,0.8L71.7,1.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk25127430);
export default __webpack_public_path__ + "static/media/AK2_5_12743_0.a9e7d631c8518699df5a930e1b22c6cb.svg";
export { ForwardRef as ReactComponent };